import ConfirmationDialog from '../ConfirmationDialog/index'
import { ReactComponent as SuccessIcon } from './success.svg'

const AccountActivatedDialog = () => (
  <ConfirmationDialog
    positiveMessage="Great!"
    confirmLink="/billing"
    closeLink="/billing"
    title="Your account is activated!"
    titleIcon={<SuccessIcon />}
  >
    <p>Payment method is added to your account succesfully.</p>
  </ConfirmationDialog>
)

export default AccountActivatedDialog
